module.exports = __webpack_public_path__ + "static/reservation-status-change-2a238c68d2ab3e5265fd7b6ca76e6b1c.png";